CheckoutV2.PaymentV2.CreditCard.New = function(checkout, $container, fromModal) {
    var method = this;

    this.$billingAddressModal = $('#billingAddressModal');

    this.$inputCardNumber = null;
    this.$inputExpirationMonth = null;
    this.$inputExpirationYear = null;
    this.$inputCardCVV = null;

    this.isActive = true;
    this.hostedFieldsInterface = false;
    this.btStyles = {
        'input' : {
            'font-size' : checkout.useLargeFont ? "16px" : "14px",
            'font-family' : "Trebuchet MS, Roboto, Arial, sans-serif",
            'font-weight' : "normal",
        },
        ':focus' : {
            'color' : "#282828",
        },
        '.valid' : {
            'color' : "#093",
        },
    };
    this.data = {}

    this._currentPayments = [];

    // Flag used to denote when the split payment modal is open as we don't want to update
    // the initial cards billing address after while the split payment modal is open
    this._splitPaymentModalOpen = false;

    this._isValid = true;

    this._init = function() {
        if( ! fromModal ) {
            // Event listener for billing info changes.
            checkout.billinfo.registerInfoChangedListener(method._onBillInfoChanged);
            checkout.registerStepFailedListener( function() {
                if ( checkout.currentStepName() == "payment" ) {
                    method._validateCardInfo( function() {
                        checkout.nextStep();
                    } );
                }
            } );

            // Event listener for split payment modal hide
            checkout.payment.splitPaymentModal.setModalHiddenCallback(method._onModalHiddenCallback);
        }

        // If there is a payment active in the payment module, we are coming back from an added card removal
        // in split payments where the last card left was an added card and this method was reinited
        if(checkout.payment.getAddedCards().length && ! fromModal) {
            // Set the current payments to the single element in addedCards
            method._currentPayments.push(checkout.payment.getAddedCards()[0]);
            // Remove that card from addedCards so if the user goes back to split again,
            // we wont end up saving a duplicate of this under a new id
            checkout.payment.removeAddedCard(method._currentPayments[0].id);
            // At this point everything prefills with the card data and validate will create a new card
            // with a new id while tracking changes.
            method._render();
            method._setBillInfoFromPayment();
            method._renderBillInfo();
            method._listen();
        } else {
            method._render();
            method._renderBillInfo();
            method._listen();
        }

        checkout.payment.getBT( function( btID ) { method.createHostedFields( btID ) } );
    };

    this._listen = function() {
        // Listener for change billing address click to show the modal
        $container.find('.js-change-billing-address').on('click', function(e){
            e.preventDefault();
            method.$billingAddressModal.modal('show');
        });

        //Listener for the split payment button to launch the split payment modal
        $container.find('.js-split-payment').on('click', function(e) {
            e.preventDefault();

            method._validateCardInfo( function() {
                method._splitPaymentModalOpen = true;

                checkout.payment.splitPaymentModal.setCardSelectedCallback(method._onSplitPaymentAdded);
                checkout.payment.splitPaymentModal.renderNewCard();
            } );
        });
    };

    this._render = function() {
        var $content = $($.parseHTML(Jemplate.process('includes/partials/payment/creditCard.html')));
        $container.find('.payment-method-creditcard-container').html($content);
        $container.find('.js-what-is-this').popover({
            content: $('.js-popover-wrapper').html(),
            html: true,
            trigger: 'focus',
            placement: 'left',
            boundary: 'window',
            offset: "-40",
            container: $container.find('.js-credit-card .what-is-this')[0]
        });

        method.$inputCardNumber = $container.find('input[name="cardnumber"]');
        method.$inputExpirationMonth = $container.find('input[name="expireMonth"]');
        method.$inputExpirationYear = $container.find('input[name="expireYear"]');
        method.$inputCardCVV = $container.find('input[name="cvv"]');

        $container.find('.collapse').addClass('show');
    };

    this._renderBillInfo = function() {
        var session = checkout.session.get();
        $container.find('.js-billing-display').html(
            Jemplate.process('includes/partials/billingInfo.html', {
                billing_firstname: session.billing.firstname,
                billing_lastname: session.billing.lastname,
                billing_address1: session.billing.address1,
                billing_address2: session.billing.address2,
                billing_city: session.billing.city,
                billing_state: session.billing.state,
                billing_zip: session.billing.zip
            })
        );
    };

    this._setBillInfoFromPayment = function() {
        //Billinfo speaks a different data structure than our payment methods
        var data = {
            'firstname': method._currentPayments[0].first_name,
            'lastname': method._currentPayments[0].last_name,
            'address1': method._currentPayments[0].address,
            'address2': method._currentPayments[0].address2,
            'city': method._currentPayments[0].city,
            'country': method._currentPayments[0].country,
            'zip': method._currentPayments[0].zip,
            'state': method._currentPayments[0].state
        };
        checkout.billinfo.setSessionData(data);
    };

    /*
    this._setCardInfoFromPayment = function() {
        method.$inputCardNumber.val(method._currentPayments[0].card_number);
        method.$inputExpirationMonth.val(method._currentPayments[0].expire_month);
        method.$inputExpirationYear.val(method._currentPayments[0].expire_year);
        method.$inputCardCVV.val(method._currentPayments[0].cvv);
    };
    */

    // When we add a split payment from a new card, we add the new payment method
    // to the active methods in payment. Then we switch payment methods to credit card again,
    // which inits stored credit card as the active payment method but with the split payment view active.
    // Data wise, split payments by design must have "added cards", so we can take advantage of stored to do it all
    // instead of having new card duplicate the functionality
    this._onSplitPaymentAdded = function(card) {
        // clean up the hosted fields
        var newCard = method._currentPayments[0];
        newCard.hostedFieldsInterface.teardown();
        newCard.hostedFieldsInterface = null;
        method.hostedFieldsInterface = null;

        // Add the card from the initial form. The modal added the other card
        checkout.payment.addNewCard( newCard );

        method._currentPayments.push(card);
        method._setPaymentActiveMethods();

        // This will change the payment method to stored cards with the existing payment methods in payment
        // Stored cards will know we have split payments from there
        checkout.payment.setMethodByName('creditcard');
    };

    this._onModalHiddenCallback = function() {
        method._splitPaymentModalOpen = false;
    };

    this._setNewCard = function(card) {
        method._currentPayments = [];
        method._currentPayments.push(card);
    };

    // Sets the payment modules active methods
    this._setPaymentActiveMethods = function(){
        checkout.payment.setActivePaymentMethods(method._currentPayments);
    };

    this._validateCardInfo = function( callback ) {
        method._isValid = false;
        checkout.payment.loading( "Verifying Payment Details" );
        method.clearFieldErrors();

        var session = checkout.session.get();
        checkout.payment.models.paymentMethodFromNewCard(
            session.billing,
            checkout.cart.totals.values.remaining,
            method.hostedFieldsInterface,
            function( paymentMethod ) {
                if( paymentMethod.nonce ) {
                    method._isValid = true;
                    checkout.payment.onMethodValid();
                    method._setNewCard(paymentMethod);
                    method._setPaymentActiveMethods();
                    if( callback && typeof callback == "function" ) callback();
                }
                else {
                    checkout.payment.onMethodInvalid();
                    method.showFieldErrors( paymentMethod );
                }
                checkout.payment.loading( false );
            }
        );
    };

    this.clearFieldErrors = function() {
        $container.find( ".js-validity-cardnumber, .js-validity-month-year, .js-validity-cvv, .js-validity-month-year-cvv" ).hide();
    };

    this.showFieldErrors = function( paymentMethod ) {
        if ( ! paymentMethod.cvv && ! paymentMethod.expire_date ) {
            $container.find( ".js-validity-month-year-cvv" ).show();
        }
        else if ( ! paymentMethod.cvv ) {
            $container.find( ".js-validity-cvv" ).show();
        }
        else if ( ! paymentMethod.expire_date ) {
            $container.find( ".js-validity-month-year" ).show();
        }

        if ( ! paymentMethod.card_number ) {
            $container.find( ".js-validity-cardnumber" ).show();
        }
    };

    // Update the current credit card billing info when billing info changes
    // Only if we have a method in the first place and the split payments modal isn't opened
    this._onBillInfoChanged = function() {
        if(method._currentPayments.length && !method._splitPaymentModalOpen){
            var billinfo = checkout.billinfo.getData().billing;
            method._currentPayments[0] = checkout.payment.models.updateBillInfoOnNewCard(method._currentPayments[0], billinfo);
            if( ! fromModal ) method._setPaymentActiveMethods();
            method._renderBillInfo();
        }
    };

    this.destroy = function() {
        // Unbind module event listeners
        checkout.billinfo.removeInfoChangedListener(method._onBillInfoChanged);
        checkout.payment.splitPaymentModal.setModalHiddenCallback(function(){});
        checkout.removeStepFailedListener(method._validateCardInfo);

        // Unbind dom event listeners
        $container.find('.js-split-payment').off('click');
        $container.find('.js-change-billing-address').off('click');
        $container.find('form.js-credit-card input').off('input');

        method.isActive = false;
    };

    this.createHostedFields = function( btID ) {
        method.hostedFieldsInterface = false;
        checkout.payment.loading( "Loading Payment Method" );

        method.setHostedFieldIDs( btID );

        if ( ! window.braintree ) return console.error( "Missing BT interface" );
        window.braintree.hostedFields.create(
            {
                'client' : checkout.payment.bt,
                'styles' : method.btStyles,
                'fields' : {
                    'number' : {
                        'selector' : "#bt-cc-" + btID,
                    },
                    'cvv' : {
                        'selector' : "#bt-cvv-" + btID,
                    },
                    'expirationDate' : {
                        'selector' : "#bt-exp-" + btID,
                        'placeholder' : "MM/YY",
                    },
                },
            },
            function( err, hostedFieldsInterface ) {
                // if this payment has already been disposed of while we were setting
                // up the hosted fields, we don't care about whether they succeeded
                if ( ! method.isActive ) return;

                if ( err ) {
                    console.error( "Hosted fields failed", err );
                    checkout.payment.showErrors( "Failed to verify payment details, try again later" );
                }
                else {
                    method.hostedFieldsInterface = hostedFieldsInterface;
                }

                checkout.payment.loading( false );
            }
        );
    };

    this.setHostedFieldIDs = function( btID ) {
        var fields = [ "cc", "exp", "cvv" ];
        $.each( fields, function( i, field ) {
            var $field = $container.find( ".js-bt-" + field );
            $field.attr( "id", "bt-" + field + "-" + btID );
        } );
    };

    this._init();
};
